import * as React from "react";
import { useFeature } from "@radarly/core/features/use-cases";

const old_path =
  "M20.26 7a4.45 4.45 0 013.3 1.43 9.2 9.2 0 002.86-1.09 4.5 4.5 0 01-2 2.46A8.15 8.15 0 0027 9.13a9.4 9.4 0 01-2.25 2.33V12A12.79 12.79 0 015 22.93a7.89 7.89 0 001.09 0 8.83 8.83 0 005.58-1.92 4.49 4.49 0 01-4.22-3.12 6 6 0 00.84.08 5 5 0 001.16-.13 4.66 4.66 0 01-3.57-4.53 5 5 0 002.06.56 4.55 4.55 0 01-2-3.77 4.25 4.25 0 01.61-2.25 12.81 12.81 0 009.31 4.71 8.42 8.42 0 01-.08-1 4.53 4.53 0 014.5-4.5z";
const new_path =
  "M17.91 14.44l7.45-8.66H23.6l-6.47 7.51-5.17-7.51H6l7.82 11.37L6 26.23h1.76l6.83-7.94 5.45 7.94H26l-8.1-11.79h.01zm-2.42 2.8l-.79-1.14-6.29-9h2.71l5.09 7.27.79 1.14 6.61 9.45H20.9l-5.39-7.71h-.01z";

function SvgTwitter(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  const TWITTER_TO_X = useFeature("twitter_to_x");

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <rect fill="currentColor" width={32} height={32} rx={6} ry={6} />
      <path fill="#fff" d={TWITTER_TO_X ? new_path : old_path} />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgTwitter);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
